import styled from 'styled-components';

const Wrapper = styled.section`
  .main-image-container {
    position: relative;
    width: 100%;
    /* aspect-ratio: 4 / 5; replaced with padding hack */
    padding-bottom: 125%;
    height: 0;
    overflow: hidden;
    border-radius: 0.75rem;
    background: #f0f0f0;
  }

  .main {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 0.75rem;
  }

  img {
    width: 100%;
    display: block;
    border-radius: 0.5rem;
    object-fit: cover;
  }

  .gallery {
    margin-top: 1rem;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 0.75rem;

    img {
      aspect-ratio: 1;
      cursor: pointer;
      opacity: 0.7;
      transition: all 0.2s;
      border: 2px solid transparent;
      padding: 2px;

      &:hover {
        opacity: 1;
      }
    }
  }

  .active {
    opacity: 1 !important;
    border-color: #111718 !important;
  }

  @media (max-width: 576px) {
    .main-image-container {
      padding-bottom: 100%; /* Square aspect ratio fallback */
    }
  }
`;

export default Wrapper;
